import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule, routingComponents } from '@src/app/app-routing.module';
import { AppComponent } from '@src/app/app.component';
import { LoginComponent } from '@src/app/login/login.component';
import { RegistrierenComponent } from '@src/app/registrieren/registrieren.component';
import { ProjektneuComponent } from '@src/app/projektneu/projektneu.component';
import { ContactComponent } from '@src/app/contact/contact.component';
import { FormsModule } from '@angular/forms';
import { AgbComponent } from '@src/app/agb/agb.component';
import { AdminComponent } from '@src/app/admin/admin.component';
import { AutoGeneratedComponent } from '@src/app/auto-generated/auto-generated.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MeinprofilComponent } from '@src/app/meinprofil/meinprofil.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AppComponent,
    routingComponents,
    LoginComponent,
    RegistrierenComponent,
    ProjektneuComponent,
    ContactComponent,
    AgbComponent,
    AdminComponent,
    AutoGeneratedComponent,
    MeinprofilComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
